import { isDateInRange } from "../datetime";

export function generateBadgingReport(badgeData, students, metrics, usageWindow, badgingLocale) {
  const {startDate, endDate} = usageWindow;
  
  const badgesByStudentId = {}
  for (const badge of badgeData) {
    const {studentId} = badge;
    if (!(studentId in badgesByStudentId)) badgesByStudentId[studentId] = []
    badgesByStudentId[studentId].push(badge);
  }

  const report = []
  for (let i = 0; i < students.length; i++) {
    const student = students[i];
    const metric = metrics[i];
    const {id, first_name, last_name} = student;
    let earnedCount = 0;
    const badgesByType = {}
    const badges = badgesByStudentId[id] || []
    
    // filtered to badges within the current usage window
    let filteredBadges = badges.filter(badge => isDateInRange(badge.createdAt, startDate, endDate));

    // filtered to badges that match the selected locale
    if (!badgingLocale.english) filteredBadges = filteredBadges.filter(badge => badge.locale !== 'EN_US');
    if (!badgingLocale.spanish) filteredBadges = filteredBadges.filter(badge => badge.locale !== 'ES_MX');

    for (const badge of filteredBadges) {
      const { awarded, locale, badgeTypeId } = badge;
      if (awarded) earnedCount++;
      const badgeTypeWithLocale = `${badgeTypeId}|${locale}`;
      if (!(badgeTypeWithLocale in badgesByType)) badgesByType[badgeTypeWithLocale] = [];
      badgesByType[badgeTypeWithLocale].push(badge);
    }

    const allAwardableBadges = badges.filter(badge => !badge.awarded);

    const tableRow = {
      studentId: id,
      firstName: first_name,
      lastName: last_name,
      earnedCount,
      badges: badgesByType,
      badgeCount: filteredBadges.length,
      allAwardableBadges,
    }

    if (metric) {
      tableRow.activityCount =  metric?.activityCount?.total
      tableRow.sessionTime = Math.round(metric?.sessionTime?.sum / (1000*60))
    }

    report.push(tableRow)
  }

  return report;
}